import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const {t,  i18n } = useTranslation();

  const languages = [
    { code: 'en', label: 'US', flag: '🇺🇸' },
    { code: 'de', label: 'DE', flag: '🇩🇪' }
  ];

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
    localStorage.setItem('selectedLanguage', languageCode);
  };

  return (
    <div className="language-selector">
      <div className="language-selector-title">
        <span>{t('sidebar.language')}</span>
      </div>
      <div className="language-options">
        {languages.map((lang) => (
          <button
            key={lang.code}
            className={`language-option ${i18n.language === lang.code ? 'active' : ''}`}
            onClick={() => handleLanguageChange(lang.code)}
          >
            <span className="language-label">{lang.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector;